module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.9ff12f69.ttf";